<main *ngIf="!!project">
    <h2>Projekt <cds-icon shape="two-way-arrows"></cds-icon> {{ companyid }}.{{ displayProjectId }} <cds-icon shape="two-way-arrows"></cds-icon>
        {{ project.name_project }}
    </h2>
    <p>
        <span class="label label-light-blue">Projektverantwortlich: {{ staffFirstName }} {{ staffLastName }} ({{ project.employee_phm }})</span>
        <span class="label label-light-blue">Projektstart: {{ formatProjectDate(project.start_project) }}</span>
        <span class="label label-light-blue">Projektende: {{ formatProjectDate(project.end_project) }}</span>
        <span class="label label-light-blue" *ngIf="project.budget > 0">Projektbudget: {{ project.budget | currency: 'EUR':'code':'1.2-2':'de' }}</span>
        <span class="label label-light-blue" *ngIf="project.budget == 0">Projektbudget: ---</span>
        <span class="label {{ statusLabel }}">Status: {{ statusText }}
            <clr-dropdown [clrCloseMenuOnItemClick]="true">
        <button clrDropdownTrigger aria-label="Dropdown demo button">
            <cds-icon shape="angle" direction="down"></cds-icon>
        </button>
        <clr-dropdown-menu *clrIfOpen>
          <label class="dropdown-header" aria-hidden="true">Status ändern</label>
          <div class="dropdown-divider" role="separator" aria-hidden="true"></div>
          <ng-container *ngFor="let item of statusButtons let i = index" >
            <div clrDropdownItem *ngIf="!item.locked" (click)="changeProjectStatus(companyid, projectid, i)">
              <span>{{ item.display }}</span>
            </div>
          </ng-container>
        </clr-dropdown-menu>
      </clr-dropdown>
    </span>
    </p>



    <div class="clr-row">
        <div class="clr-col-lg-12 clr-col-md-12 clr-col-12">
            <div class="card">
                <div class="card-header">
                    <span *ngIf="project.description">{{ project.description }}</span>
                    <hr *ngIf="project.description">
                    <cds-icon shape="upload" size="l" (click)="showFileUploader()"></cds-icon> <small class="ml1">&nbsp;Kundenanfrage archivieren&nbsp;</small>
                </div>
                <div class="card-block">
                    <div class="card-text">
                        <clr-tabs>

                            <clr-tab *ngIf="(statusText === 'Auftrag') || (statusText === 'Erledigt')">
                                <button clrTabLink>Jobs</button>
                                <clr-tab-content clrTabContentId="content0" *clrIfActive="true">
                                    <app-project-details-jobs [prid]="projectid" [cid]="companyid"></app-project-details-jobs>
                                    <!--<app-projekte-details-controlling [prid]="projectid" [cid]="companyid"></app-projekte-details-controlling>-->
                                </clr-tab-content>
                            </clr-tab>

                            <clr-tab>
                                <button clrTabLink>Projektübersicht</button>
                                <clr-tab-content clrTabContentId="content1" *clrIfActive>
                                    <br>
                                    <app-project-details-stammdaten [cidstd]="companyid" [pridstd]="projectid" [basedata]="project" ></app-project-details-stammdaten>
                                    <app-project-details-positions [cidPos]="companyid" [pridPos]="projectid"></app-project-details-positions>
                                </clr-tab-content>
                            </clr-tab>

                            <clr-tab>
                                <button clrTabLink>Requests</button>
                                <clr-tab-content  clrTabContentId="content2" *clrIfActive>
                                    <app-project-details-requests [cid]="companyid" [prid]="projectid"></app-project-details-requests>
                                </clr-tab-content>
                            </clr-tab>

                            <clr-tab *ngIf="(statusText === 'Auftrag') || (statusText === 'Erledigt')">
                                <button clrTabLink>Orders</button>
                                <clr-tab-content clrTabContentId="content3" *clrIfActive>
                                    <app-project-details-order [cid]="companyid" [prid]="projectid"></app-project-details-order>
                                    <app-project-details-transport [projectID]="companyid + '.' + projectid"></app-project-details-transport>
                                </clr-tab-content>
                            </clr-tab>

                            <clr-tab>
                                <button clrTabLink>Offers</button>
                                <clr-tab-content clrTabContentId="content5" *clrIfActive>
                                    <app-project-details-offer [cid]="companyid" [prid]="projectid"></app-project-details-offer>
                                </clr-tab-content>
                            </clr-tab>

                            <clr-tab *ngIf="(statusText === 'Auftrag') || (statusText === 'Erledigt')">
                                <button clrTabLink>Lieferschein</button>
                                <clr-tab-content clrTabContentId="content5" *clrIfActive>
                                    <app-project-details-delivery [cidstd]="companyid" [pridstd]="projectid" ></app-project-details-delivery>
                                </clr-tab-content>
                            </clr-tab>

                            <clr-tab *ngIf="(statusText === 'Auftrag') || (statusText === 'Erledigt')">
                                <button clrTabLink>Invoices</button>
                                <clr-tab-content clrTabContentId="content6" *clrIfActive>
                                    <app-project-details-invoices [cidstd]="companyid" [pridstd]="projectid" [reqid]=project.request_id [pid]="project.employee_leader ?? 0"></app-project-details-invoices>
                                </clr-tab-content>
                            </clr-tab>

                            <clr-tab>
                                <button clrTabLink>Dokumente</button>
                                <clr-tab-content clrTabContentId="content8" *clrIfActive>
                                    <app-project-details-documents></app-project-details-documents>
                                </clr-tab-content>
                            </clr-tab>

                            <clr-tab>
                              <button clrTabLink>CRM Sync</button>
                              <clr-tab-content clrTabContentId="content9" *clrIfActive>
                                <div class="clr-row" *ngIf="crmMode">
                                  <div class="clr-col-lg-12 clr-col-md-12 clr-col-12">
                                    <div class="card">
                                      <div class="card-header">CRM Sync (Projekt)</div>
                                      <div class="card-block">
                                        <div class="card-text">
                                          <table class="table table-vertical">
                                            <tbody>
                                            <tr>
                                              <th>Status</th>
                                              <td><span [class]="crmCompareClass">{{ crmCompareLabel }}</span></td>
                                            </tr>
                                            <tr>
                                              <th>Projekt-Key</th>
                                              <td>{{ crmProjectRef || '-' }}</td>
                                            </tr>
                                            <tr>
                                              <th>CRM-ID</th>
                                              <td>{{ crmCompare?.crm_id ?? project?.crm_id ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                              <th>Sync-State</th>
                                              <td>{{ crmCompare?.crm_sync_state ?? project?.crm_sync_state ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                              <th>Letzter Sync</th>
                                              <td>{{ crmCompare?.crm_sync_at ?? project?.crm_sync_at ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                              <th>Fehler</th>
                                              <td>{{ crmCompare?.crm_sync_error ?? project?.crm_sync_error ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                              <th>Compare Fehler</th>
                                              <td>{{ crmCompare?.compare_error ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                              <th>Blocking Issues</th>
                                              <td class="crm-blocking-issues">
                                                <span *ngIf="!crmCompare?.blocking_issues?.length">-</span>
                                                <span *ngFor="let issue of crmCompare?.blocking_issues"
                                                      class="label label-sm label-danger crm-issue-label">{{ issue }}</span>
                                              </td>
                                            </tr>
                                            <tr *ngIf="crmCompare?.diffs?.length">
                                              <th>Feldvergleich</th>
                                              <td>
                                                <table class="table table-compact crm-diff-table">
                                                  <thead>
                                                  <tr>
                                                    <th>Feld</th>
                                                    <th>PPS</th>
                                                    <th>CRM</th>
                                                    <th>Status</th>
                                                  </tr>
                                                  </thead>
                                                  <tbody>
                                                  <tr *ngFor="let diff of crmCompare?.diffs">
                                                    <td>{{ getDiffFieldLabel(diff.field) }}</td>
                                                    <td>{{ diff.pps || '-' }}</td>
                                                    <td>{{ diff.crm || '-' }}</td>
                                                    <td>
                                                <span [class]="diff.equal ? 'label label-sm label-success' : 'label label-sm label-danger'">
                                                  {{ diff.equal ? 'gleich' : 'abweichend' }}
                                                </span>
                                                    </td>
                                                  </tr>
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                            </tbody>
                                          </table>
                                          <div>
                                            <br />
                                            <button class="btn btn-sm btn-primary" (click)="syncCrmNow()" [disabled]="crmSyncRunning || crmCompareLoading">
                                              {{ crmSyncRunning ? 'Synchronisiere...' : 'Jetzt synchronisieren' }}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </clr-tab-content>
                            </clr-tab>

                        </clr-tabs>
                    </div>
                </div>
                <div class="card-footer">
                    <small>Projektverantwortlich: {{ staffFirstName }} {{ staffLastName }} ({{ project.employee_phm }})</small>
                </div>
            </div>
        </div>
    </div>

</main>

<ng-container *ngIf="showFileUpload">
    <clr-modal id="fileUploader" [(clrModalOpen)]="showFileUpload" [clrModalStaticBackdrop]="false">

        <h3 class="modal-title">Kundenanfrage archivieren</h3>
        <div class="modal-body">
            <app-upload [componentId]="'0'" [projectId]="companyid + '.' + projectid" [companyId]=0  [jobId]=0 [subId]=0 [docType]=99 (closeModalEvent)="closeModal($event)"></app-upload>
        </div>

    </clr-modal>
</ng-container>
